import { render, staticRenderFns } from "./ModalScheduleMessage.vue?vue&type=template&id=654ca91e&scoped=true&"
import script from "./ModalScheduleMessage.vue?vue&type=script&lang=js&"
export * from "./ModalScheduleMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalScheduleMessage.vue?vue&type=style&index=0&id=654ca91e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ca91e",
  null
  
)

export default component.exports